/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelOptionResponse
 */
export interface LabelOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof LabelOptionResponse
     */
    text: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabelOptionResponse
     */
    color: string | null;
}

/**
 * Check if a given object implements the LabelOptionResponse interface.
 */
export function instanceOfLabelOptionResponse(value: object): value is LabelOptionResponse {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function LabelOptionResponseFromJSON(json: any): LabelOptionResponse {
    return LabelOptionResponseFromJSONTyped(json, false);
}

export function LabelOptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelOptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'color': json['color'],
    };
}

export function LabelOptionResponseToJSON(json: any): LabelOptionResponse {
    return LabelOptionResponseToJSONTyped(json, false);
}

export function LabelOptionResponseToJSONTyped(value?: LabelOptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'color': value['color'],
    };
}

